// Drop facet values containing angle brackets. Not jsdom-DOMPurify, which leaked memory per request on SSR.
function sanitizeFilterValue(val) {
  return typeof val === 'string' && !/[<>]/.test(val) ? val : ''
}

export default function getAppliedValues(facet, route) {
  const vals = route.query[facet]

  if (!vals || vals === '') {
    return []
  }

  if (Array.isArray(vals)) {
    return vals
      .map(sanitizeFilterValue)
      .filter(val => !!val)
  }

  return [vals]
    .map(sanitizeFilterValue)
    .filter(val => !!val)
}
